import { TextField } from "@mui/material";
import type { FC } from "react";

interface Props {
  id?: string;
  label: string;
  value: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  margin?: "dense" | "none" | "normal";
  onChange: (value: string) => void;
}

const TimePicker: FC<Props> = ({ label, value, size, fullWidth, disabled, readonly, margin, onChange }) => (
  <TextField
    label={label}
    type="time"
    size={size}
    fullWidth={fullWidth}
    disabled={disabled}
    margin={margin}
    value={value}
    slotProps={{
      inputLabel: { shrink: true },
      htmlInput: { "aria-label": label, role: "time" },
      input: { readOnly: readonly },
    }}
    onChange={(e) => onChange(e.target.value)}
  />
);

export default TimePicker;
